const FAQ_ITEMS = [
  {
    q: '番茄影视的资源是否需要付费？',
    a: '完全不需要。番茄影视大全所有影视资源均可免费在线观看，无需注册、无需会员、无需任何费用，真正做到零门槛畅享高清影视。',
  },
  {
    q: '播放画质如何？会卡顿吗？',
    a: '本站提供1080P至4K超清画质选项，配备智能CDN加速和自适应码率技术，根据您的网络环境自动优化播放体验，绝大多数用户都能流畅观看不缓冲。',
  },
  {
    q: '资源更新频率是怎样的？',
    a: '番茄影视保持每日更新，热播剧集通常在播出后2小时内上线，电影、综艺、动漫等也会第一时间同步更新片源，确保追剧不等待。',
  },
  {
    q: '支持哪些设备观看？',
    a: '番茄影视完美适配电脑、平板、手机等多种终端设备，无需安装任何插件或APP，打开浏览器即可观看。同时提供移动端优化界面，操作便捷流畅。',
  },
  {
    q: '资源是否齐全？有分类搜索吗？',
    a: '本站片库覆盖电影、电视剧、综艺、动漫、纪录片等全类型，超过10万部资源。支持按类型、年份、地区、评分等多维度浏览筛选，快速定位想看的影片。',
  },
  {
    q: '遇到播放问题怎么办？',
    a: '如遇到播放异常，建议优先尝试切换线路或刷新页面。大部分播放问题与网络环境有关。若问题持续存在，可通过联系我们页面提交反馈，技术团队会尽快处理。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">常见问答</h2>
          <p className="text-sm text-foreground-500 mt-2">关于番茄影视的常见问题解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {FAQ_ITEMS.map((item, idx) => (
            <details key={idx} className="group bg-background-100 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-200/70 transition-colors list-none">
                <h3 className="text-sm font-semibold text-foreground-950 pr-4 font-heading">{item.q}</h3>
                <span className="shrink-0 w-6 h-6 rounded-full bg-background-200 flex items-center justify-center group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-foreground-500 text-sm" />
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}